var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { getInitials, getName, } from "@rentiohq/shared-frontend/dist/redux/contact/contact.utils";
import { Tooltip } from "../../Tooltip";
import { AccountIndicator } from "./AccountIndicator";
export var EmployeeIndicator = function (props) {
    var employeeAccount = props.employeeAccount;
    return (_jsx(Tooltip, { tooltipContent: getName(employeeAccount), children: _jsx(AccountIndicator, __assign({}, props, { children: getInitials(employeeAccount) })) }));
};
